import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './App.css';
import './index.css';
const root = ReactDOM.createRoot(document.getElementById('root'));
async function mount() {
  try {
    console.warn('react-helmet-async imported but HelmetProvider not found — rendering without it.');
    root.render(<App />);
  } catch (err) {
    console.warn('react-helmet-async not available, rendering without HelmetProvider.', err);
    root.render(<App />);
  }
}
mount();
